import { useIsMutating } from 'react-query';
import { Link } from 'react-router-dom';
import useQueryParams from 'utils/useQueryParams';
import ListingLayout from 'components/Layout/ListingLayout';
import ROUTES from 'app/routes';
import Table from 'pages/Venues/Listing/components/Table';
import Footer from 'components/Footer';
import LoadingIndicator from 'components/LoadingIndicator';
import { useGetVenues } from 'api/venues';

function Venues() {
  const { queryString } = useQueryParams({
    page_size: '10',
    page: '1',
  });

  const isMutating = !!useIsMutating({ mutationKey: ['venuesMutation'] });

  const {
    isFetching,
    data: { data: venues, totals } = { data: [], totals: 0 },
  } = useGetVenues(queryString);

  const showLoading = isMutating || isFetching;

  return (
    <ListingLayout
      title="Obiekty"
      subtitle="Aby zdefiniować ścieżkę zwiedzania lub plan, skorzystaj z menu funkcjonalnego umieszczonego na końcu tabeli"
      headerButtons={[
        {
          label: 'NOWY OBIEKT',
          as: Link,
          to: ROUTES.venues.create,
        },
      ]}
    >
      {showLoading && <LoadingIndicator />}
      {!showLoading && <Table data={venues} />}
      <Footer totals={totals} footerButtons={null} />
    </ListingLayout>
  );
}

export default Venues;
